import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export interface PlaceOrderForm {
  poNumber: string;
  orderInstruction: string;
  deliveryMethod: string;
  isCustomerInitiatedQuote: boolean;
  email: string;
  firstName: string;
  lastName: string;
  plant: string;
  timeZone: string;
  language: string;
  country: string;
  hasPMA: boolean;
  optime: boolean;
  unloadingPoint: string;
  paymentType: string;
  creditCardID: string;
  freightPaymentCode: string;
  freightPaymentAccountNumber: string;
  orderType: string;
  completeDelivery: boolean;
  trackUid: string;
}

export enum ErrorCode {
  Generic = "error.generic",
  CreditCard = "error.creditCard",
  SaleStock = "error.saleStock",
}

interface Response {
  success: boolean;
  errorCode?: ErrorCode;
  orderCode?: string;
  analytics?: {
    purchaseValueEur?: number;
  };
}

export async function apiSubmitPlaceOrder(form: PlaceOrderForm): Promise<Response> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot place an order without an Active Cart");
  }

  const url = occBaseSiteUrl(`/users/current/carts/${encodeURIComponent(activeCartId)}/placeOrder`);
  const response = await occFetch(url, {
    body: JSON.stringify(form),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Could not place order: ${response.status}`);
  }
  return response.json() as Promise<Response>;
}
